<div class="event-effects-dialog">
  <div class="header">
    <div class="name">
      <img class="ghs-svg" [src]="'./assets/images/event' + (menu ? '-effects' : '') + '.svg'"> <span [ghs-label]="'scenario.eventEffects' + (menu ? '.hint' : 
    '')"></span>
    </div>
    @if (!menu && characters.length) {
    <div class="text">
      <span [ghs-label]="'scenario.eventEffects.hint'"></span>
    </div>
    }

    <div class="characters"
      [ngClass]="{'denied' : gameManager.stateManager.permissions && (!gameManager.stateManager.permissions.characters || !gameManager.stateManager.permissions.party)}">
      @for (character of characters| trackUUID; track character._trackUUID) {
      <div class="character-container">
        <a class="character" tabclick ghs-pointer-input (singleClick)="toggleCharacter(character)"
          (doubleClick)="openCharacterSheet(character)"
          [ngClass]="{'inactive' : !activeCharacters.includes(character)}">
          <img class="icon" [src]="character.iconUrl">
          @if (character.absent) {
          <img class="absent" src="./assets/images/status/absent.svg">
          }
        </a>
        @if (!gameManager.roundManager.firstRound) {
        @for (summon of character.summons | trackUUID; track summon._trackUUID) {
        <a class="summon" tabclick (click)="toggleSummon(summon)"
          [ngClass]="{'inactive' : !activeSummons.includes(summon), 'thumbnail' : settingsManager.settings.artwork && (summon.thumbnail && !summon.noThumbnail || summon.thumbnailUrl)}">
          <span class="summon-state" [ngClass]="{'fh': summon.color == SummonColor.fh}">
            @if (summon.color != SummonColor.fh) {
            <img src="./assets/images/summons/{{summon.color}}.png">
            }
            <span class="summon-number">
              @if (summon.number == 0) {
              <span>-</span>
              }
              @if (summon.number > 0) {
              <span>{{summon.number}}</span>
              }</span>
          </span>
          @if (settingsManager.settings.artwork && (summon.thumbnail && !summon.noThumbnail || summon.thumbnailUrl)) {
          <div class="background-image"
            [style.background-image]="summon.thumbnailUrl ? 'url(' +  summon.thumbnailUrl + ')' : 'url(./assets/images/summons/thumbnail/' + summon.thumbnail + '.png)'">
          </div>
          }
        </a>
        }
        }
      </div>
      }
      @if (gameManager.trialsManager.favorsEnabled) {
      <a class="favors" (click)="openFavors()">
        <span [ghs-label]="'scenario.favors'"></span>
      </a>
      }
      @if (gameManager.imbuementManager.enabled) {
      <div class="imbuement">
        <span class="title" [ghs-label]="'scenario.gh2eImbuement'"></span>
        <div class="checkboxes">
          @if (gameManager.imbuementManager.imbuement != 'advanced') {
          <label (click)="toggleImbuement()">
            <span class="input-checkbox"
              [ngClass]="{'checked' : gameManager.imbuementManager.imbuement == true}"></span>
            <span [ghs-label]="'scenario.gh2eImbuement.imbuement'"></span>
          </label>
          }
          @if (gameManager.imbuementManager.available == 'advanced' && gameManager.imbuementManager.imbuement != true) {
          <label (click)="toggleImbuement(true)">
            <span class="input-checkbox"
              [ngClass]="{'checked' : gameManager.imbuementManager.imbuement == 'advanced'}"></span>
            <span [ghs-label]="'scenario.gh2eImbuement.advancedImbuement'"></span>
          </label>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <div class="scroll-container container"
    [ngClass]="{'denied' : gameManager.stateManager.permissions && (!gameManager.stateManager.permissions.characters || !gameManager.stateManager.permissions.party)}">

    @if (!!gameManager.game.scenario && characters.length) {
    <div class="entity-container">
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.health'" [ghs-label-attribute]="'title'">
        <img src="./assets/images/status/health.svg" />
        <span class="badge"
          [ngClass]="{'negative-value' : minHealth() < 0, 'positive-value' : maxHealth() > 0}">{{(minHealth() < 0 ?
            minHealth() : maxHealth()) | ghsValueSign}}</span>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeHealth(1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/plus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeBless(-1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/minus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item" [ghs-tooltip]="'game.condition.bless.hint'" [originX]="'center'" [overlayX]="'center'"
          [originY]="'top'" [overlayY]="'bottom'">
          <img src="./assets/images/status/bless.svg" />
          <span class="badge" [ngClass]="{'negative-value' : bless < 0, 'positive-value' : bless > 0}">{{bless |
            ghsValueSign}}</span>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeBless(1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/plus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeCurse(-1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/minus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item" [ghs-tooltip]="'game.condition.curse.hint'" [originX]="'center'" [overlayX]="'center'"
          [originY]="'top'" [overlayY]="'bottom'">
          <img src="./assets/images/status/curse.svg" />
          <span class="badge" [ngClass]="{'negative-value' : curse < 0, 'positive-value' : curse > 0}">{{curse |
            ghsValueSign}}</span>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeCurse(1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/plus.svg">
          </ghs-pointer-input>
        </span>
    </div>
    }

    @if (!!gameManager.game.scenario && characters.length) {
    <ghs-conditions [entities]="activeCharacters" [entityConditions]="entityConditions" [immunities]="newImmunities"
      [type]="'character'" (conditionChange)="changeConditions($event)"></ghs-conditions>
    }

    @if (characters.length || settingsManager.settings.fhShareResources) {
    <div class="entity-container">
      @if (characters.length) {
      <span class="progress"><span [ghs-label]="'scenario.eventEffects.progress'"></span></span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeExperience(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'game.experience'" [ghs-label-attribute]="'title'">
        <img src="./assets/images/status/experience.svg" />
        <span class="badge"
          [ngClass]="{'negative-value' : minExperience() < 0, 'positive-value' : maxExperience() > 0}">{{(minExperience()
          < 0 ? minExperience() : maxExperience()) | ghsValueSign}}</span>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeExperience(1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/plus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item">
          <ghs-pointer-input class="button" tabclick (singleClick)="changeGold(-1)" [repeat]="true">
            <img class="ghs-svg" src="./assets/images/minus.svg">
          </ghs-pointer-input>
        </span>
        <span class="item" [ghs-label]="'character.progress.gold'" [ghs-label-attribute]="'title'">
          <img class="ghs-svg" [ngClass]="{'gold' : !gameManager.fhRules()}"
            [src]="'./assets/images/' + (gameManager.fhRules() ?'fh/'  :'') +'loot.svg' " />
          <span class="badge"
            [ngClass]="{'negative-value' : minGold() < 0, 'positive-value' : maxGold() > 0}">{{(minGold() < 0 ?
              minGold() : maxGold()) | ghsValueSign}}</span>
          </span>
          <span class="item">
            <ghs-pointer-input class="button" tabclick (singleClick)="changeGold(1)" [repeat]="true">
              <img class="ghs-svg" src="./assets/images/plus.svg">
            </ghs-pointer-input>
          </span>
          <span class="item">
            <ghs-pointer-input class="button" tabclick (singleClick)="changeBattleGoals(-1)" [repeat]="true">
              <img class="ghs-svg" src="./assets/images/minus.svg">
            </ghs-pointer-input>
          </span>
          <span class="item" [ghs-label]="'game.battleGoals'" [ghs-label-attribute]="'title'">
            <input type="checkbox" disabled="true" checked="true">
            <span class="badge"
              [ngClass]="{'negative-value' : minBattleGoals() < 0, 'positive-value' : maxBattleGoals() > 0}">{{(minBattleGoals()
              < 0 ? minBattleGoals() : maxBattleGoals()) | ghsValueSign}}</span>
            </span>
            <span class="item">
              <ghs-pointer-input class="button" tabclick (singleClick)="changeBattleGoals(1)" [repeat]="true">
                <img class="ghs-svg" src="./assets/images/plus.svg">
              </ghs-pointer-input>
            </span>
            }

            @if (settingsManager.settings.fhShareResources) {
            <span class="progress"><span [ghs-label]="'scenario.eventEffects.progressShare'"></span></span>
            }
            @for (type of lootColumns; track type) {
            <span class="item">
              <ghs-pointer-input class="button" tabclick (singleClick)="changeLoot(type, -1)" [repeat]="true">
                <img class="ghs-svg" src="./assets/images/minus.svg">
              </ghs-pointer-input>
            </span>
            <span class="item" [ghs-label]="'game.loot.' + type" [ghs-label-attribute]="'title'">
              <img class="ghs-svg" [src]="'./assets/images/fh/loot/' + type + '.svg'">
              <span class="badge"
                [ngClass]="{'negative-value' : minLoot(type) < 0, 'positive-value' : maxLoot(type) > 0}">{{(minLoot(type)
                < 0 ? minLoot(type) : maxLoot(type)) | ghsValueSign}}</span>
              </span>
              <span class="item">
                <ghs-pointer-input class="button" tabclick (singleClick)="changeLoot(type, 1)" [repeat]="true">
                  <img class="ghs-svg" src="./assets/images/plus.svg">
                </ghs-pointer-input>
              </span>
              }
    </div>
    }

    @if (settingsManager.settings.partySheet) {
    <div class="entity-container campaign">
      <span class="progress"><span [ghs-label]="'scenario.eventEffects.campaign'"></span></span>
      @if (settingsManager.settings.events) {
      @for (type of eventTypes; track type) {
      <span class="event-deck-container">
        <a class="action" tabclick (click)="drawEvent(type)" [ghs-label]="'scenario.eventEffects.drawEvent'"
          [ghs-label-args]="[type]"
          [ngClass]="{'disabled' : !gameManager.game.party.eventDecks[type] || gameManager.game.party.eventDecks[type].length == 0}"></a>
        <img (click)="setupEvents(type)" class="ghs-svg" src="./assets/images/settings.svg"
          [ghs-tooltip]="'game.events.deck.setup'">
      </span>
      }
      @if (gameManager.fhRules() && !eventAttack) {
      <span class="action" tabclick (click)="openOutpostAttack()"
        [ghs-label]="'scenario.eventEffects.outpostAttack'"></span>
      }
      }
      @if (gameManager.roundManager.firstRound) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeProsperity(-1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'party.prosperity'" [ghs-label-attribute]="'title'">
        @if (gameManager.fhRules()) {
        <img class="ghs-svg" src="./assets/images/fh/prosperity.svg" />
        }
        <span [ghs-label]="'party.prosperity'"></span>
        <span class="badge"
          [ngClass]="{'negative-value' : prosperity < 0, 'positive-value' : prosperity > 0}">{{prosperity |
          ghsValueSign}}</span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeProsperity(1)" [repeat]="true">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      @if (!gameManager.fhRules()) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeReputation(-1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.reputation + reputation <= -20}">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'party.reputation'" [ghs-label-attribute]="'title'">
        <span [ghs-label]="'party.reputation'"></span>
        <span class="badge"
          [ngClass]="{'negative-value' : reputation < 0, 'positive-value' : reputation > 0}">{{reputation |
          ghsValueSign}}</span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeReputation(1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.reputation + reputation >= 20}">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (gameManager.fhRules()) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeMorale(-1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.morale + morale <=0}">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'party.morale'" [ghs-label-attribute]="'title'">
        <span [ghs-label]="'party.morale'"></span>
        <span class="badge" [ngClass]="{'negative-value' : morale < 0, 'positive-value' : morale > 0}">{{morale |
          ghsValueSign}}</span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeMorale(1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.morale + morale >= 20}">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      @if (gameManager.fhRules()) {
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeInspiration(-1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.inspiration + inspiration <=0}">
          <img class="ghs-svg" src="./assets/images/minus.svg">
        </ghs-pointer-input>
      </span>
      <span class="item" [ghs-label]="'party.inspiration'" [ghs-label-attribute]="'title'">
        <span [ghs-label]="'party.inspiration'"></span>
        <span class="badge"
          [ngClass]="{'negative-value' : inspiration < 0, 'positive-value' : inspiration > 0}">{{inspiration |
          ghsValueSign}}</span>
      </span>
      <span class="item">
        <ghs-pointer-input class="button" tabclick (singleClick)="changeInspiration(1)" [repeat]="true"
          [ngClass]="{'disabled' : gameManager.game.party.inspiration + inspiration >= 20}">
          <img class="ghs-svg" src="./assets/images/plus.svg">
        </ghs-pointer-input>
      </span>
      }
      }
      <span class="action" tabclick (click)="drawRandomItem()"
        [ghs-label]="'scenario.eventEffects.drawRandomItem'"></span>
      @if (gameManager.fhRules()) {
      <span class="action" tabclick (click)="drawRandomItem(true)"
        [ghs-label]="'scenario.eventEffects.drawRandomItem.blueprint'"></span>
      }
      <span class="action" tabclick (click)="drawRandomScenario(gameManager.fhRules())"
        [ghs-label]="'scenario.eventEffects.drawRandomScenario'"></span>
    </div>
    }

    @if (eventEffectsManual.length || eventConditionManual.length || !!eventAttack || eventOutpostAttackEffects.length)
    {
    <div class="entity-container event-outcomes">
      @if (eventEffectsManual.length || eventConditionManual.length) {
      <span class="title" [ghs-label]="'game.events.applyManually'"></span>
      }
      @for (condition of eventConditionManual | trackUUID; track condition._trackUUID) {
      <ghs-event-card-condition [condition]="condition" [light]="true" [selected]="true"></ghs-event-card-condition>
      }
      @for (effect of eventEffectsManual; track (typeof effect === 'object' ? effect.type : effect) + $index) {
      <ghs-event-card-effect [effect]="effect" [light]="true" [selected]="true"></ghs-event-card-effect>
      }
      @if (!!eventAttack) {
      <span class="title outpost" [ghs-label]="'game.events.outpostAttack'"></span>
      }
      @if (eventOutpostAttackEffects.length) {
      <span class="title" [ghs-label]="'game.events.outpostAttack.effects'"></span>
      }
      @for (effect of eventOutpostAttackEffects; track (typeof effect === 'object' ? effect.type : effect) + $index) {
      <ghs-event-card-effect [effect]="effect" [light]="true" [selected]="true"></ghs-event-card-effect>
      }
      @if (!!eventAttack) {
      <ghs-event-card-attack [attack]="eventAttack" [light]="true" [selected]="true" [narrative]="false"
        [effects]="false" [disabled]="true" (click)="openOutpostAttack()"></ghs-event-card-attack>
      }
      <a class="action" (click)="openPartySheet()" [ghs-label]="'campaign.party'"></a>
    </div>
    }
  </div>
</div>